import React, {
  useState
} from 'react'
import TitlePage from 'components/atoms/title-page'
import CustomerCartsApiV2 from 'api/v2/admins/customer-carts-api-v2'
import PropTypes from 'prop-types'
import { ALERT_TYPES } from 'constants/alert-constants'
import CustomerCheckoutCartForm from 'domains/customer-checkout/organisms/cart-form'
import CustomerCheckoutTable from 'domains/customer-checkout/organisms/table'
import { Link } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  CardFooter
} from 'reactstrap'
import UserSelectSearchField from 'domains/user/organisms/user-select-search-field'
import { Formik, Form } from 'formik'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CustomerCheckoutCartPage = ({ pageUtils }) => {
  const [ cart, setCart ]                           = useState(null)
  const [ user, setUser ]                           = useState(null)
  const [ selectedCartItems, setSelectedCartItems ] = useState([])

  /**
   * Method that triggered when Ops check/select linked `Customer::Order`
   */
  const handleSelectCartItem = (newCartItem) => {
    setSelectedCartItems((prevState) => (
      [ ...prevState, newCartItem ]
    ))
  }

  /**
   * Method that triggered when Ops uncheck/unselect linked `Customer::Order`
   */
  const handleUnselectCartItem = (selectedCartItem) => {
    setSelectedCartItems((prevState) => (
      prevState.filter((cartItem) => cartItem.id !== selectedCartItem.id)
    ))
  }

  const toggleCartItemCheckbox    = (checked, cartItem) => {
    if (checked) {
      handleUnselectCartItem(cartItem)
    } else {
      handleSelectCartItem(cartItem)
    }
  }
  const toggleAllCartItemCheckbox = () => {
    const checked = selectedCartItems.length === cart.items.length

    if (checked) {
      setSelectedCartItems([])
    } else {
      setSelectedCartItems(cart.items)
    }
  }

  const [ isTableLoading, setIsTableLoading ] = useState(false)

  const handleFetchCarts = (values) => {
    CustomerCartsApiV2.get(values.user.customer.id)
      .then((response) => {
        setUser(values.user)
        setCart(response.data.cart)
        setSelectedCartItems([])
        setIsTableLoading(false)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }

  // Add item to cart
  const handleClickAddItem = async (values, formik) => {
    await CustomerCartsApiV2.add_item(values)
      .then(() => {
        pageUtils.setAlertMsg('Successfully add item to cart!', ALERT_TYPES.SUCCESS)
        handleFetchCarts({ user })
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally(() => {
        formik.resetForm()
      })
  }

  // Remove item to cart
  const handleClickRemoveItem = async (cartItemIds) => {
    const isRemoveAction = window.confirm('Are you sure to remove this item?')

    if (!isRemoveAction) return
    await CustomerCartsApiV2.remove_item(
      user.customer.id,
      cartItemIds
    )
      .then(() => {
        pageUtils.setAlertMsg('Successfully remove item to cart!', ALERT_TYPES.SUCCESS)
        handleFetchCarts({ user })
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }

  const handleRemoveMultipleCartItems = () => {
    const cartItemIds = selectedCartItems.map((cartItem) => cartItem.id)
    handleClickRemoveItem(cartItemIds)
  }

  return (
    <>
      <TitlePage mainTitle={ 'Add/Remove' } subTitle={ 'cart items customer' } />
      <Formik
        enableReinitalize={ false }
        initialValues={{ user: '' }}
        onSubmit={ handleFetchCarts }
      >
        {
          () => (
            <Form>
              <UserSelectSearchField
                name='user'
                label='user'
                required={ true }
              />
            </Form>
          )
        }
      </Formik>

      <div className='d-flex justify-content-end mb-2'>
        {
          selectedCartItems.length > 0 && (
            <Button
              onClick={ handleRemoveMultipleCartItems }
              color='danger'
            >
              { `Remove ${selectedCartItems.length} item(s)` }
            </Button>
          )
        }
      </div>

      {
        cart && (
          <Card key={ `cart-${cart.id}` }>
            <CustomerCheckoutTable
              cart={ cart }
              isLoading={ isTableLoading }
              hiddenColumns={ [] }
              selectedCartItems={ selectedCartItems }
              toggleAllCheckbox={ toggleAllCartItemCheckbox }
              toggleCheckbox={ toggleCartItemCheckbox }
              rowButtonProps={{
                buttonText    : 'Remove',
                buttonColour  : 'danger',
                onButtonClick : handleClickRemoveItem
              }}
            />
            <CardBody>
              <CustomerCheckoutCartForm
                customer={ user.customer }
                onSubmit={ handleClickAddItem }
              />
            </CardBody>
            <CardFooter>
              <div className='float-right'>
                <Button
                  color='primary'
                  size='bg'
                  tag={ Link }
                  disabled={ cart.items < 1 }
                  to={{
                    pathname : `/app/customer-service/customers/${ user.customer.id }/checkout`,
                    state    : {
                      cartItemIds: selectedCartItems?.map((item) => item.id)
                    }
                  }}
                >
                  { 'Checkout' }
                </Button>
              </div>
            </CardFooter>
          </Card>
        )
      }
    </>
  )
}

CustomerCheckoutCartPage.propTypes    = propTypes
CustomerCheckoutCartPage.defaultProps = defaultProps

export default CustomerCheckoutCartPage
